/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UpdateBlueprintResponse {
    getFixupPrototypeFunction() { return UpdateBlueprintResponse.fixupPrototype; }

    static newInstance(model: Partial<UpdateBlueprintResponse>): UpdateBlueprintResponse {
        let obj = Object.assign(new UpdateBlueprintResponse(), model);
        UpdateBlueprintResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UpdateBlueprintResponse>): UpdateBlueprintResponse {
        if (!model) return null;
        return UpdateBlueprintResponse.newInstance(<UpdateBlueprintResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UpdateBlueprintResponse) {
        if (!obj) return;

        models.UpdateBlueprintResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UpdateBlueprintResponse): boolean {
        Object.setPrototypeOf(obj, UpdateBlueprintResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Blueprint ID
     */
    blueprint_id: string;

}
